import { useCallback } from "react";

import { IntlShape } from "react-intl";

const usePercentageValueFormatter = (intl: IntlShape) =>
  useCallback(
    (value: number): string => {
      return intl.formatNumber(value, {
        maximumFractionDigits: 1,
        minimumFractionDigits: 0,
        style: "percent",
      });
    },
    [intl]
  );

export default usePercentageValueFormatter;
